import { safetyChecks } from '@/mocks/siteData';

export default function SafetyCenter() {
  return (
    <section className="py-16 md:py-20 bg-background-100">
      <div className="max-w-[1200px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <span className="inline-block px-4 py-1.5 rounded-full bg-accent-100 text-accent-800 text-xs font-semibold mb-4 whitespace-nowrap">
            Safety Center
          </span>
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 mb-3">
            Is Sugargoo Spreadsheet Safe?
          </h2>
          <p className="text-foreground-500 max-w-2xl mx-auto text-sm leading-relaxed">
            We take your safety seriously. Here is what you need to know to shop confidently and avoid common pitfalls.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-5 mb-10">
          {safetyChecks.map((item, idx) => (
            <div
              key={idx}
              className="flex gap-4 p-5 bg-background-50 rounded-xl border border-background-200/60"
            >
              <div className="flex-shrink-0 w-10 h-10 flex items-center justify-center rounded-lg bg-accent-100 text-accent-600">
                <i className="ri-error-warning-line text-lg"></i>
              </div>
              <div>
                <h4 className="font-semibold text-foreground-800 text-sm mb-1">{item.risk}</h4>
                <p className="text-sm text-foreground-500 leading-relaxed">{item.protection}</p>
              </div>
            </div>
          ))}
        </div>

        <div className="bg-background-50 rounded-2xl border border-background-200/60 p-6 md:p-8 text-center">
          <div className="w-12 h-12 flex items-center justify-center rounded-xl bg-secondary-100 text-secondary-600 mx-auto mb-4">
            <i className="ri-information-line text-xl"></i>
          </div>
          <h3 className="font-heading text-lg font-semibold text-foreground-900 mb-3">Important Disclaimer</h3>
          <p className="text-sm text-foreground-500 max-w-2xl mx-auto leading-relaxed">
            This website is an independent information platform. We are not the official Sugargoo website. Always verify information before making purchases. External links to our main website are provided as a convenience — we recommend reading all terms and conditions on the destination site.
          </p>
        </div>
      </div>
    </section>
  );
}